import { DropsContextProvider } from '../Drops/DropsContext';
import { DROP } from '../common';
import { PlayerContextProvider } from '../Player/PlayerContext';
import HomePage from './HomePage';

const FuturaPlayer = () => {

  return (
    <DropsContextProvider drop={DROP.futura}>
      <PlayerContextProvider>
        <HomePage />
      </PlayerContextProvider>
    </DropsContextProvider>
  )
}

export default FuturaPlayer;
